<div class="modal-container">
  <button
    id="modalSeleccionTipoUsuario"
    #modalSeleccionTipoUsuario
    data-bs-toggle="modal"
    data-bs-target="#modalTipoUsuario"
    hidden="hidden"
    hidden
    aria-hidden="true"
    tabindex="-1">
    Launch
  </button>
  <div
    class="modal fade"
    id="modalTipoUsuario"
    data-bs-backdrop="static"
    data-bs-keyboard="false"
    tabindex="-1"
    aria-labelledby="modalTitle"
    aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title h5-tipografia-govco">
            Seleccione un tipo de usuario
          </h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <app-form
            [fields]="fieldsTiposDeUsuario"
            [sumbitButtonText]="'Aceptar'"
            (submitAction)="onSubmitSeleccionarTipoUsuario($event)"></app-form>
        </div>
      </div>
    </div>
  </div>
</div>
